var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTop25Green(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 12,
    viewBox: "0 0 32 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 8,
    height: 12,
    fill: "#90B17A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 12,
    fill: "#63666E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5.5,
    width: 6,
    height: 1,
    fill: "#63666E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 1,
    height: 12,
    fill: "#63666E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 7.5,
    height: 1,
    fill: "#63666E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 7.5,
    height: 1,
    fill: "#63666E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    width: 1,
    height: 12,
    fill: "#63666E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    width: 7.5,
    height: 1,
    fill: "#63666E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 11,
    width: 7.5,
    height: 1,
    fill: "#63666E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 1,
    height: 12,
    fill: "#63666E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 5.5,
    width: 6,
    height: 1,
    fill: "#63666E"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    width: 1,
    height: 12,
    fill: "#63666E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop25Green);
export default __webpack_public_path__ + "static/media/top25Green.aaaa6fe914a6ab06676afd2ace3c4c2a.svg";
export { ForwardRef as ReactComponent };